<template>
  <div
    class="rl__card"
    v-bind:class="[hover ? 'rl__card-hover' : '', activeClass, isHidden ? 'rl__card-hide' : '', disable ? 'rl__card-disable' : '' ]"
    v-on:click="setActiveItem($event)"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div class="rl__card_container" ref="container">
      <div class="rl__card_image" >
        <img :class="addHorizontalImgClass(type) ? 'rl__card_image-horizontal' : ''" :src="getIcon(type)" :aria-hidden="true"/>
      </div>
       <div v-show="!isSelected" class="rl__card_info">
        <div v-show="!isSelected" class="rl__card_type">
        <v-clamp autoresize :max-lines="1"> {{ type.toUpperCase() }}</v-clamp>
    </div>
    <div v-show="!isSelected" class="rl__card_headline">
      <div>{{headline | truncate(100, '...')}}</div>      
    </div>
      </div>
  
      <div v-show="isSelected" class="rl__card_expanded" >
        <div class="rl__card_type">{{ type.toUpperCase() }}</div>
        <div class="rl__card_headline" v-if="headline!== ''">
          <div>{{headline | truncate(85, '...')}}</div> 
        </div>
        <div class="rl__card_tag">
           <v-clamp autoresize :max-lines="1">{{ tags.join(" | ") }}</v-clamp>
        </div>
        <div v-if="products && products.length > 0" class="rl__card_products">{{ products.join(" | ").replaceAll('_', ' ') }}</div>
        <div v-if="industries && industries.length > 0" class="rl__card_industries">{{ industries.join(" | ").replaceAll('_', ' ') }}</div>
        <div class="rl__card_description" v-if="description!== ''">
         <v-clamp autoresize :max-lines="1"> {{ description }}</v-clamp>
        </div>
        <div class="ctx-text rl__card_action" v-if="isVideo && $i18n.locale!=='zh'">
          <a><span class="rl__resource-link ctx-style-orphaned-link ctx-img-link ctx-modal-link" :data-options="getYoutubeId">{{$t('view')}} {{ type }}</span></a>
        </div>
          <div class="ctx-text rl__card_action" v-else>
          <a v-if="isInternalLink" :href="getLink" ><span class="rl__resource-link ctx-style-orphaned-link">{{$t('view')}} {{ type }}</span></a>
          <a v-if="!isInternalLink" :href="getYoukuUrl" target="_blank"><span class="rl__resource-link">{{$t('view')}} {{ type }}</span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixins from "../mixins/common";
import imageClassMapper from "../utils/iconMap";
import VClamp from 'vue-clamp';
import Vue from 'vue';

export default {
  name: "Card",
  mixins: [commonMixins],
  components: {
    VClamp
  },
  props: {
    data: Object,
    activeClass: String,
    isHidden: Boolean,
    isSelected: Boolean,
    onClick: {
      type: Function,
    },
  },
  data() {
    return {
      disable: this.data.disable,
      type: this.data.type,
      headline: this.data.headline,
      tags: this.data.tags,
      products: this.data.products,
      description: this.data.description,
      industries: this.data.industries,
      link: this.data.link[this.$i18n.locale] || "",
      hover: false,
      siteName: "",
      localeMapper: {
        "da" : "da-dk",
        "de" : "de-de",
        "en-au" : "en-au",
        "en-gb" : "e-gb",
        "en-in" : "en-in",
        "en-us" : "en_us",
        "es" : "es-es",
        "fi" : "fi-fi",
        "fr" : "fr-fr",
        "it" : "it-it",
        "ja" : "ja-jp",
        "ko" : "ko-kr",
        "nl" : "nl-nl",
        "no" : "no-no",
        "pl" : "pl-pl",
        "pt" : "pt-br",
        "ru" : "ru-ru",
        "sv" : "sv-se",
        "tr" : "tr-tr",
        "zh" : "zh-cn"
      },
      horizontalImgClass: ''
    };
  },

  methods: {
   setActiveItem(event) {
      const classList = event.target.classList;
      if (!classList.contains("rl__resource-link")) {
        const isExpanded = this.isSelected;
        const refs = this.$refs;
        if (!this.isSelected) {
          this.onClick();
        }
        Vue.nextTick(() => {
          if (isExpanded)
            refs.container.querySelector(".rl__card_action a span").click();
        });
      }
    },

    getIcon(type) {
      if(imageClassMapper.hasOwnProperty(type)) return `/content/dam/${this.siteName}/resource-library-new/`+ imageClassMapper[type];
      else return `/content/dam/${this.siteName}/resource-library-new/`+ imageClassMapper["Technical guide"];
    },

    addHorizontalImgClass(type) {
      const types = ["Video", "Assessment tool", "Podcast", "Webinar", "Interactive tour", "Demo", "Dr. Jaspersoft Webinar"].map(type => type.toLowerCase())
      return types.includes(type.toLowerCase())
    }  
  },
  computed : {
    getYoutubeId() {    
      if(this.link.indexOf('youtube') > -1) {
      const queryParams = new RegExp('[\?&]' + 'v' + '=([^&#]*)').exec(this.link);
        if (queryParams){
           return `videoId:${decodeURI(queryParams[1]) || 0};type:youtube` 
      }
     else {
       return null;
      }
    }  
  },

  isVideo() {
      return this.link.indexOf('youtube') > 1 ;
  },

  isInternalLink() {
    return this.link.includes(`/content/${this.siteName}/`)
  },

  getLink() {
      if(this.link.includes('/content/citrix')) return this.link.replace('en_us', this.localeMapper[this.$i18n.locale])
      else return this.link
    },
    getYoukuUrl() {
      if(this.link.indexOf('youtube') > -1 && this.$i18n.locale === 'zh') return `https://i.youku.com/i/UMzU2OTI4MzY0`   
      else return this.link
    }
  },
  created() {
    this.siteName = window.CTX_RL.siteName ? window.CTX_RL.siteName : this.extractSiteName(window.location.host);
  }
};
</script>

<style scoped lang="scss">
@import "../css/_global.scss";
@import "../css/components/card.scss";

.rl__card-disable {
  pointer-events: none;
  visibility: hidden;
}

.rl__card_info {
  width: 200px;
}
.rl__card {
  position: relative;
  width: calc(33% - 17px);
  height: 200px;
  cursor: pointer;
  background-color: #f3f3f3;
  @include prefix(transition, transform 250ms ease-in-out);

  &:hover {
    transform: scale(1.02, 1.02);
    transition: transform 250ms ease;
    font-size: 16px;
    @include prefix(box-shadow, 0px 0px 5px 2px rgba(0, 0, 0, 0.18));
  }
}

.rl__card.selected {
  .rl__card_container {
    padding: 8px 10px 10px 10px;
  }
}

.rl__card {
  .rl__card_container {
    padding: 8px 20px 20px 20px;
  }
}

.rl__card_image > .rl__card_image-horizontal {
  margin-top: 35px;
}

.rl__card_image {
  float: right;
  margin-left: 15px;

  img {
    margin: 25px 0px 12px;
  }
}

.rl__card.selected .rl__card_image img {
  margin: 25px 10px 12px;
}

.rl__card_expanded {
  margin: 0 10px;

    .ctx-text {
    padding-top: 0;
  }
}

.rl__card_action a[target='_blank']::after, .rl__card_action a[target='_blank']::after {
    content: "\e91d";
    font-family: "Citrix-Icons";
    margin-left: 4px;
    font-size: .75rem;
}

.rl__card-hide {
  display: none;
}

[data-value="1"].selected,
[data-value="2"].selected,
[data-value="3"].selected {
  flex: 2 2 50%;
  max-width: calc(100% - 34%);
  transform: scale(1.01, 1.01) !important;
  @include prefix(box-shadow, 0px 0px 5px 2px rgba(0, 0, 0, 0.18));
}

[data-value="2"].selected {
  margin: 1% !important;
}

[data-value="3"].selected {
  .rl__card_container {
      direction: rtl;
  }
  .rl__card_expanded {
     direction: ltr;
  }
}

.rl__card_industries , .rl__card_products {
  display: none;
}
</style>
